/**
 * Form validation — HTML5 constraint validation + OctoberCMS AJAX error display.
 * Waits for jQuery (loaded by OctoberCMS framework) before binding AJAX events.
 */

export function initValidation() {
  // Display AJAX error messages — bind when jQuery becomes available
  function bindAjaxErrors() {
    const $ = window.jQuery || window.$;
    if ($) {
      $(window).on('ajaxErrorMessage', (event, message) => {
        $('.error-message').show().text(message.trim());
        event.preventDefault();
      });
    }
  }

  // Try immediately, or wait for jQuery to load via framework scripts
  if (window.jQuery || window.$) {
    bindAjaxErrors();
  } else {
    // OctoberCMS framework loads jQuery after DOMContentLoaded via {% scripts %}
    const check = setInterval(() => {
      if (window.jQuery || window.$) {
        clearInterval(check);
        bindAjaxErrors();
      }
    }, 100);
    setTimeout(() => clearInterval(check), 10000);
  }

  // HTML5 constraint validation for forms with .needs-validation
  document.querySelectorAll('.needs-validation').forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    });
  });
}
